<template>
  <div class="location-body">
    <template v-for="(item, index) in iconList">
      <div
        class="location-item"
        v-if="item"
        :key="index"
        @click.stop="toLink(item.link)"
      >
        <img
          class="icon-hot"
          v-if="tooltipsObj[item.tooltipsKey]"
          :src="tooltipsObj[item.tooltipsKey].image"
          alt=""
        />
        <img class="location-icon" :src="item.image" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/api/api-list";
import { loginMixin, envMixin } from "@/assets/js/mixin/global";
export default {
  mixins: [loginMixin, envMixin],
  name: "goodLocation",
  props: {
    isStudent: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getGoodLocaltion();
    this.getTooltips();
  },
  data() {
    return {
      hotImg: "https://files.wondercv.com/cvs/isHot.gif",
      iconList: [
        {
          image: "https://files.wondercv.com/cvs/cv-sample-1.png", // 大牛案例
          link: `${process.env.VUE_APP_HOST}/jianlimoban/tuijian/`,
          title: "大牛案例",
          tooltipsKey: "31",
        },
        {
          image: "https://files.wondercv.com/cvs/cv-mentor-1.png", // 简历修改
          link: `${process.env.VUE_APP_HOST}/service`,
          title: "简历修改",
          tooltipsKey: "32",
        },
        null,
        {
          image: "https://logo.wondercv.com/banners/LQ0JspXO4P7Ytk5.png", // 求职意向
          link: `${process.env.VUE_APP_HOST}/lesson`,
          title: "求职课程",
          tooltipsKey: "34",
        },
        //  {
        //    image: 'https://files.wondercv.com/cvs/interview-1.png', // 求职意向
        //    link: `${process.env.VUE_APP_HOST}/live`,
        //    title: "直播招聘",
        //    tooltipsKey: '34'
        //  }
      ],
      tooltipsObj: {},
    };
  },
  methods: {
    // 获取金刚位气泡
    getTooltips() {
      let tooltip1 = api.jobs.getBannerImg({ position: 31 });
      let tooltip2 = api.jobs.getBannerImg({ position: 32 });
      let tooltip3 = api.jobs.getBannerImg({ position: 33 });
      let tooltip4 = api.jobs.getBannerImg({ position: 34 });
      try {
        Promise.all([tooltip1, tooltip2, tooltip3, tooltip4]).then((res) => {
          if (res) {
            let tooltips = {};
            if (res[0].data.length) tooltips["31"] = res[0].data[0];
            if (res[1].data.length) tooltips["32"] = res[1].data[0];
            if (res[2].data.length) tooltips["33"] = res[2].data[0];
            if (res[3].data.length) tooltips["34"] = res[3].data[0];
            this.tooltipsObj = tooltips;
          }
        });
      } catch (e) {}
    },
    // 获取金刚位banner
    getGoodLocaltion() {
      // if(this.isAlipayClient){
      // return
      // }
      api.jobs
        .getBannerImg({ position: 27 })
        .then((res) => {
          if (res.code === 1000 && res.data && res.data.length) {
            this.iconList.splice(2, 1, { tooltipsKey: "33", ...res.data[0] });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toLink(url) {
      if (url.search("/job/intentions") != -1 && !this.alreadyLogged) {
        this.needLogin();
      } else if (url.search('/service') !== -1) {
        this.$fn.switch(`/pages/service/index`, () => {
          window.location.href = url;
        });
      } else {
        this.$fn.jump(url);
        // window.location.href = url
      }
    },
  },
};
</script>

<style scoped lang="scss">
.location-body {
  display: flex;
  padding-top: 20px;
  padding-bottom: 12px;
  background-color: #fff;
}
.location-item {
  position: relative;
  flex: 1;
  .icon-hot {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -20px;
    right: 12px;
  }
  .location-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
    display: block;
    margin: auto;
    margin-bottom: 8px;
  }
  & > div {
    text-align: center;
    color: #404040;
    font-size: 13px;
    font-weight: 400;
  }
}
</style>
